import { Injectable } from '@angular/core';
import { BehaviorSubject } from 'rxjs';

@Injectable({ providedIn: 'root' })
export class PageTitleService {
  primaryPageTitle$: BehaviorSubject<string> = new BehaviorSubject(null);
  secondaryPageTitle$: BehaviorSubject<string> = new BehaviorSubject(null);
  tertiaryPageTitle$: BehaviorSubject<string> = new BehaviorSubject(null);

  constructor() {}

  setPrimaryPageTitle(value: string): void {
    this.primaryPageTitle$.next(value);
  }

  setSecondaryPageTitle(value: string): void {
    this.secondaryPageTitle$.next(value);
  }

  setTertiaryPageTitle(value: string): void {
    this.tertiaryPageTitle$.next(value);
  }

  clearPrimaryPageTitle(): void {
    this.primaryPageTitle$.next(null);
  }

  clearSecondaryPageTitle(): void {
    this.secondaryPageTitle$.next(null);
  }

  clearTertiaryPageTitle(): void {
    this.tertiaryPageTitle$.next(null);
  }
}
